/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Few_Late_Bear_EvokeInputs */

const fr_few_late_bear_evoke = /** @type {(inputs: Few_Late_Bear_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas d'historique pour le moment`)
};

/**

* @param {Few_Late_Bear_EvokeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const few_late_bear_evoke = /** @type {((inputs?: Few_Late_Bear_EvokeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Few_Late_Bear_EvokeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_few_late_bear_evoke(inputs)
});